module.exports = __webpack_public_path__ + "static/media/plus.0ad74278.png";